module.exports = __webpack_public_path__ + "static/media/cricket.d33ef8af.ogg";